var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-icon"},[_c('v-img',{attrs:{"src":_vm.url,"height":"24px","width":"24px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }